<template>
  <v-card >
    <v-toolbar card>
      <v-icon>domain</v-icon>
      <v-toolbar-title class="font-weight-light">Datos desde el formulario cumplimentado por los usuarios - {{ CA }}</v-toolbar-title>
      <template v-if="optionSimple">
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" @click="$emit('verDatosCons', null)">Cerrar</v-btn>
        </v-toolbar-items>
      </template>
    </v-toolbar>

    <!-- BurbujaPropietarios -->
    <v-card-text>
      <v-flex xs12 sm12>
        <BurbujaPropietarioConsolidados
          :propietario="dataBurbuja"
          :refCatastral="refCatastral" 
          :idInmueble="idInmueble"
          :CA="CA"
        />
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn color="success" @click.stop="inmuebleDatosUpdate">
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn> -->
    </v-card-actions>
    <template v-if="debug">
      <pre>optionSimple: {{ optionSimple }}</pre>
      <pre>{{dataBurbuja}}</pre>
    </template>
  </v-card>
</template>

<script>
import BurbujaPropietarioConsolidados from "./inmueble-burbuja-propietarios-consolidados"
export default {
  props: ["optionSimple", "dataBurbuja", "refCatastral", "idInmueble", "CA", "debug"],
  components: {BurbujaPropietarioConsolidados},
  data () {
    return {
      ubicacion: {},
      propietarios: []
    }
  },

  mounted() {
    // this.cargaDatos();
  },

  watch: {
    dataBurbuja() {
      // this.cargaDatos();
    }
  },

  methods: {
    /* consolida(datos) {
      const data = {
        propietarioBurbuja: datos.propietarioBurbuja,
        sessionUid: datos.sessionUid,
      }
      this.$emit('consolida', datos)
      
    },

    archiva(datos) {
      const data = {
        refCat: this.refCatastral,
        refInmueble: this.idInmueble,
        sessionUid: datos.sessionUid,
        noMostrar: true
      }
      this.$emit('archivar', data)
      console.log(data)
    },

    cargaDatos() {
      const datos = Object.assign({}, this.dataBurbuja);
      if (!datos || !datos.propietarios) {
        this.propietarios = [];
        this.ubicacion = {};
        return;
      }
      // console.log(JSON.stringify(datos));
      // this.propietarios = datos.propietarios; // Object.assign({}, this.dataBurbuja.propietarios);

      this.propietarios = this.optionSimple ? datos.propietarios : datos.propietarios.filter(i => !i.noMostrar);
      this.ubicacion = {
        escalera: datos.escalera,
        piso: datos.piso,
        letra: datos.letra
      }
    },

    inmuebleDatosUpdate() {
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleDatos: this.inmuebleDatos
      };
      this.$store.dispatch("inmuebleDatosUpdate", payload);
      this.$emit("listo");
      // this.hecho = true;
    } */
  }
}
</script>
